const prefixCls = 'web.admin.';

export const localesAdmin = {
  // 账户管理
  [prefixCls + 'account.title']: {
    zh_CN: '账户管理',
    en_GB: 'Account Management',
  },
  [prefixCls + 'account.action.permissions']: {
    zh_CN: '权限',
    en_GB: 'Permissions',
  },
  [prefixCls + 'account.action.AddSubAccount']: {
    zh_CN: '添加子账号',
    en_GB: 'Add Sub Account',
  },
  [prefixCls + 'account.action.updatePoint']: {
    zh_CN: '更新积分',
    en_GB: 'Update Points',
  },
  [prefixCls + 'account.search.placeholder']: {
    zh_CN: '请输入账户名称搜索',
    en_GB: 'Search by account name',
  },
  [prefixCls + 'account.button.create']: {
    zh_CN: '新建账户',
    en_GB: 'Create Account',
  },

  // 表格列
  [prefixCls + 'account.table.column.id']: {
    zh_CN: 'ID',
    en_GB: 'ID',
  },
  [prefixCls + 'account.table.column.name']: {
    zh_CN: '名称',
    en_GB: 'Name',
  },
  [prefixCls + 'account.table.column.site']: {
    zh_CN: '站点',
    en_GB: 'Site',
  },
  [prefixCls + 'account.table.column.company']: {
    zh_CN: '公司',
    en_GB: 'Company',
  },
  [prefixCls + 'account.table.column.linkQuota']: {
    zh_CN: '创建链接额度',
    en_GB: 'Link Creation Quota',
  },
  [prefixCls + 'account.table.column.expiryDate']: {
    zh_CN: '到期时间',
    en_GB: 'Expiry Date',
  },
  [prefixCls + 'account.table.column.createdTime']: {
    zh_CN: '创建时间',
    en_GB: 'Created Time',
  },
  [prefixCls + 'account.table.column.status']: {
    zh_CN: '状态',
    en_GB: 'Status',
  },
  [prefixCls + 'account.table.column.actions']: {
    zh_CN: '操作',
    en_GB: 'Actions',
  },

  // 操作按钮
  [prefixCls + 'account.action.edit']: {
    zh_CN: '编辑',
    en_GB: 'Edit',
  },
  [prefixCls + 'account.action.delete']: {
    zh_CN: '删除',
    en_GB: 'Delete',
  },
  [prefixCls + 'account.action.resetPassword']: {
    zh_CN: '重置密码',
    en_GB: 'Reset Password',
  },

  // 表单相关
  [prefixCls + 'account.form.title.create']: {
    zh_CN: '新增',
    en_GB: 'Create',
  },
  [prefixCls + 'account.form.title.edit']: {
    zh_CN: '编辑',
    en_GB: 'Edit',
  },
  [prefixCls + 'account.form.label.name']: {
    zh_CN: '账户',
    en_GB: 'Account',
  },
  [prefixCls + 'account.form.placeholder.name']: {
    zh_CN: '请输入账户',
    en_GB: 'Please enter account name',
  },
  [prefixCls + 'account.form.label.password']: {
    zh_CN: '密码',
    en_GB: 'Password',
  },
  [prefixCls + 'account.form.placeholder.password']: {
    zh_CN: '请输入密码',
    en_GB: 'Please enter password',
  },
  [prefixCls + 'account.form.label.site']: {
    zh_CN: '国家',
    en_GB: 'Country',
  },
  [prefixCls + 'account.form.placeholder.site']: {
    zh_CN: '请选择国家',
    en_GB: 'Please select country',
  },
  [prefixCls + 'account.form.label.company']: {
    zh_CN: '公司',
    en_GB: 'Company',
  },
  [prefixCls + 'account.form.placeholder.company']: {
    zh_CN: '请输入公司',
    en_GB: 'Please enter company',
  },
  [prefixCls + 'account.form.label.linkTotal']: {
    zh_CN: '创建链接额度',
    en_GB: 'Link Creation Quota',
  },
  [prefixCls + 'account.form.placeholder.linkTotal']: {
    zh_CN: '请输入创建链接额度',
    en_GB: 'Please enter link creation quota',
  },
  [prefixCls + 'account.form.label.expiryDate']: {
    zh_CN: '过期时间',
    en_GB: 'Expiry Date',
  },
  [prefixCls + 'account.form.placeholder.expiryDate']: {
    zh_CN: '请选择日期',
    en_GB: 'Please select date',
  },
  [prefixCls + 'account.form.label.status']: {
    zh_CN: '类型',
    en_GB: 'Type',
  },
  [prefixCls + 'account.form.button.create']: {
    zh_CN: '创建',
    en_GB: 'Create',
  },
  [prefixCls + 'account.form.button.update']: {
    zh_CN: '更新',
    en_GB: 'Update',
  },

  // 表单验证消息
  [prefixCls + 'account.form.validation.nameRequired']: {
    zh_CN: '请输入账户名',
    en_GB: 'Please enter account name',
  },
  [prefixCls + 'account.form.validation.nameMinLength']: {
    zh_CN: '账户名至少3个字符',
    en_GB: 'Account name must be at least 3 characters',
  },
  [prefixCls + 'account.form.validation.passwordRequired']: {
    zh_CN: '请输入密码',
    en_GB: 'Please enter password',
  },
  [prefixCls + 'account.form.validation.passwordMinLength']: {
    zh_CN: '密码至少6个字符',
    en_GB: 'Password must be at least 6 characters',
  },
  [prefixCls + 'account.form.validation.siteRequired']: {
    zh_CN: '请选择国家',
    en_GB: 'Please select country',
  },
  [prefixCls + 'account.form.validation.linkTotalRequired']: {
    zh_CN: '请输入创建链接额度',
    en_GB: 'Please enter link creation quota',
  },
  [prefixCls + 'account.form.validation.expiryDateRequired']: {
    zh_CN: '请选择过期时间',
    en_GB: 'Please select expiry date',
  },
  [prefixCls + 'account.form.validation.statusRequired']: {
    zh_CN: '请选择类型',
    en_GB: 'Please select type',
  },

  // 状态选项
  [prefixCls + 'account.form.status.testUser']: {
    zh_CN: '测试用户',
    en_GB: 'Test User',
  },
  [prefixCls + 'account.form.status.trial']: {
    zh_CN: '试用',
    en_GB: 'Trial',
  },
  [prefixCls + 'account.form.status.basic']: {
    zh_CN: '基础版',
    en_GB: 'Basic',
  },
  [prefixCls + 'account.form.status.professional']: {
    zh_CN: '专业版',
    en_GB: 'Professional',
  },
  [prefixCls + 'account.form.status.premium']: {
    zh_CN: '尊贵版',
    en_GB: 'Premium',
  },
  [prefixCls + 'account.form.status.blocked']: {
    zh_CN: '拉黑',
    en_GB: 'Blocked',
  },
  [prefixCls + 'account.form.status.robWarehouse']: {
    zh_CN: '抢仓',
    en_GB: 'Rush Stock',
  },
};

export default localesAdmin;
